import { contactInfo } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          联系我们
        </h2>
        <div className="max-w-[600px] mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 text-center">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {contactInfo.desc}
            </p>
            <div className="flex flex-col gap-4 max-w-[400px] mx-auto">
              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-left min-w-0">
                  <div className="text-xs text-foreground-400">电子邮箱</div>
                  <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="text-left min-w-0">
                  <div className="text-xs text-foreground-400">微信公众号</div>
                  <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.wechat}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-question-answer-line text-lg"></i>
                </div>
                <div className="text-left min-w-0">
                  <div className="text-xs text-foreground-400">QQ 客服</div>
                  <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.qq}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}